import moment from "moment";

export default {
  name: "OmApplicationTools",
  data: function () {
    return {};
  },
  created() {},
  methods: {
    createDateTimeForBackEnd(date, hours, minutes) {
      if (!date) return null;

      if (typeof date !== 'string') {
        return moment(`${moment(date).format('YYYY-MM-DD')} ${hours}:${minutes}`).format();
      }
      let temp = date.split("/");
      let dateTime = `${temp[2]}-${temp[1]}-${temp[0]} ${hours}:${minutes}`;
      return moment(dateTime).format();
    },
    createDateForBackEnd(date) {
      if (!date) return null;

      if (typeof date !== 'string') {
        return moment(date).format();
      }
      let temp = date.split("/");
      let dateTime = `${temp[2]}-${temp[1]}-${temp[0]}`;
      return moment(dateTime).format();
    },
  },
};

